export const familyArticles = [
  {
    id: 14,
    titles: {
      en: "Diagnostic Frameworks of Family Pathologies in Adolescence",
      it: "Inquadramenti Diagnostici delle Patologie Familiari nell'Adolescenza"
    },
    authors: ["Rodolfo de Bernart", "Cristina Dobrowolski"],
    descriptions: {
      en: "An in-depth analysis of diagnostic frameworks for family pathologies during adolescence, offering tools and methodologies to understand and treat complex family dynamics in this critical developmental phase.",
      it: "Un'analisi approfondita degli inquadramenti diagnostici per le patologie familiari durante l'adolescenza, offrendo strumenti e metodologie per comprendere e trattare le dinamiche familiari complesse in questa fase evolutiva critica."
    },
    publishDate: "2024-01-10",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/aabcf589-ddc6-43da-b495-00c43c5468de/introduction-diagnostic-frameworks",
        mindmap: "https://whimsical.com/diagnostic-frameworks-of-family-pathologies-in-adolescence-G4ogTFZDErceypi4nh76my",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81MTgxNDM3LzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/59834161-db4d-42d4-991d-199367fd4651/introduzione-inquadramento-diagnostico",
        mindmap: "https://whimsical.com/adolescenza-secondo-de-bernart-e-dobrowolski-UowsQJDmh7JVZgQUSe96SX",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTE4MTM5My8x"
      }
    }
  },
  {
    id: 15,
    titles: {
      en: "Inside the relationship, Outside the Family",
      it: "Dentro la relazione, fuori dalla famiglia"
    },
    authors: ["Rodolfo de Bernart"],
    descriptions: {
      en: "An exploration of family therapy dynamics focusing on the complex interplay between individual relationships within the family system and the external influences that shape family functioning and therapeutic interventions.",
      it: "Un'esplorazione delle dinamiche della terapia familiare che si concentra sulla complessa interazione tra le relazioni individuali all'interno del sistema familiare e le influenze esterne che modellano il funzionamento familiare e gli interventi terapeutici."
    },
    publishDate: "2024-01-25",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/4949f7c0-639a-4505-98c2-680c0fcede75/introduction-to-family-therapy-dynamics",
        mindmap: "https://whimsical.com/inside-the-relationship-outside-the-family-ExHkKAuZ6QzLgAR6WVJXN2",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81MTgzMjQ2LzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/306ede8e-6f76-4175-9ed7-69112dea6e26/introduzione-terapia-familiare",
        mindmap: "https://whimsical.com/dentro-la-relazione-fuori-dalla-famiglia-Ezb1ttRHpwjdALESoj7GC3",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTE4MTM5My8x"
      }
    }
  },
  {
    id: 16,
    titles: {
      en: "The Useful Couple",
      it: "La coppia utile"
    },
    authors: ["Paolo Menghi"],
    descriptions: {
      en: "An exploration of Paolo Menghi's concept of the 'useful couple' in systemic therapy, examining how therapeutic relationships and couple dynamics can be leveraged as powerful tools for change and growth in family and systemic interventions.",
      it: "Un'esplorazione del concetto di 'coppia utile' di Paolo Menghi nella terapia sistemica, esaminando come le relazioni terapeutiche e le dinamiche di coppia possano essere sfruttate come potenti strumenti per il cambiamento e la crescita negli interventi familiari e sistemici."
    },
    publishDate: "2024-02-05",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/d76eb32b-d969-4de4-8a10-a9ad287f0e33/introduction-useful-couple",
        mindmap: "https://whimsical.com/core-concepts-from-the-useful-couple-by-paolo-menghi-BAnFrMHdu8NU7yTtPQirZz",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81MTg4NzMxLzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/f8dd27d7-429c-4fe8-8978-6345374d0b41/introduzione-la-coppia-utile-paolo-menghi",
        mindmap: "https://whimsical.com/la-coppia-utile-paolo-menghi-XM2gqcedq1JVkewyAEd5oW",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTE4NzkwNS8x"
      }
    }
  },
  {
    id: 17,
    titles: {
      en: "Adolescent Suicide: A Relational Perspective",
      it: "Il suicidio dell'adolescente: una lettura relazionale"
    },
    authors: ["Lilia Gagnarli", "Cristina Dobrowolski"],
    descriptions: {
      en: "An in-depth analysis of adolescent suicide from a relational and systemic perspective, exploring family dynamics and risk factors that may contribute to suicidal behavior in adolescents.",
      it: "Un'analisi approfondita del suicidio adolescenziale da una prospettiva relazionale e sistemica, esplorando le dinamiche familiari e i fattori di rischio che possono contribuire al comportamento suicidario negli adolescenti."
    },
    publishDate: "2024-02-28",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/3bc244dd-a92a-43d1-84cb-12935ab21c7b/introduction-to-adolescent-suicide",
        mindmap: "https://whimsical.com/adolescent-suicide-a-relational-perspective-V3WZeX2fZjiJqDJ9TgwZgZ",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81MTk0MDE3LzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/563be147-f3b0-44cb-ac3c-13784556b8a2/introduzione-suicidio-adolescente",
        mindmap: "https://whimsical.com/il-suicidio-dell-adolescente-una-lettura-relazionale-Uqd6G8FpQjhRsG9UQh1ZZD",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTE5Mzk2My8x"
      }
    }
  },
  {
    id: 18,
    titles: {
      en: "The Siblings Mind",
      it: "L'importanza di essere fratelli"
    },
    authors: ["Rodolfo de Bernart"],
    descriptions: {
      en: "An exploration of sibling relationships and their fundamental role in family dynamics and individual development, examining how fraternal bonds shape personality, attachment patterns, and therapeutic interventions within a systemic framework.",
      it: "Un'esplorazione delle relazioni fraterne e del loro ruolo fondamentale nelle dinamiche familiari e nello sviluppo individuale, esaminando come i legami fraterni modellino la personalità, i pattern di attaccamento e gli interventi terapeutici all'interno di un quadro sistemico."
    },
    publishDate: "2024-03-15",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/7142ae27-b7a7-497f-b0ee-87fa815126e0/introduction-to-sibling-dynamics-in-therapy",
        mindmap: "https://whimsical.com/the-importance-of-being-siblings-Bdke9vdnkb6vu5fYKrGKar",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81MTk1NTExLzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/63efc3cc-3785-4ed6-b5e1-fe31c272cb8a/introduzione-legame-fraterno-terapia-sistemica",
        mindmap: "https://whimsical.com/l-importanza-di-essere-fratelli-YCLL8RQicak7FAXoGZi2ji",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTE5NTQ3MS8x"
      }
    }
  },
  {
    id: 19,
    titles: {
      en: "Personal Authority and Intergenerational Boundaries",
      it: "Autorità Personale e Confini Intergenerazionali"
    },
    authors: ["Donald S. Williamson"],
    descriptions: {
      en: "An exploration of Williamson's concept of achieving 'Personal Authority' by terminating intergenerational hierarchical boundaries, marking a new stage in the family life cycle.",
      it: "Un'esplorazione del concetto di Williamson di raggiungere l''Autorità Personale' attraverso la terminazione dei confini gerarchici intergenerazionali, segnando una nuova fase nel ciclo di vita familiare."
    },
    publishDate: "2024-03-30",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/ad3c6876-4772-49dc-a761-fe8215282775/introduction-personal-authority-hierarchical-boundaries",
        mindmap: "https://whimsical.com/personal-authority-according-to-williamson-NXHkcgBB1QMvTNtjUg5RSR",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81MTk2NDExLzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/0738d306-68ad-4bed-8cb7-adda5a905b00/introduzione-autorita-personale-confini-gerarchici",
        mindmap: "https://whimsical.com/l-autorita-personale-secondo-williamson-6HqPpCCSbox6WeykgVDpCZ",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTIwMjQxNi8x"
      }
    }
  },
  {
    id: 20,
    titles: {
      en: "The Family Therapist and the Family Between Two Geological Eras: The Real and the Symbolic",
      it: "Il terapeuta familiare e la famiglia tra due ere geologiche: quella del reale e quella del simbolico"
    },
    authors: ["Ancilla Dal Medico"],
    descriptions: {
      en: "An exploration of family therapy in the context of contemporary societal transformations, examining how families navigate between the 'real' era of traditional structures and the 'symbolic' era of digital and virtual relationships.",
      it: "Un'esplorazione della terapia familiare nel contesto delle trasformazioni societarie contemporanee, esaminando come le famiglie navigano tra l'era del 'reale' delle strutture tradizionali e l'era del 'simbolico' delle relazioni digitali e virtuali."
    },
    publishDate: "2024-04-12",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/3bf22a51-e6d0-406d-93f4-d79ea10e79de/introduction-to-family-dynamics",
        mindmap: "https://whimsical.com/generated-board-FRJQER2YMNsjLYEmomL7Dh",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81MjA1MjU1LzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/32f78a74-0e19-4de2-91e0-e9dbc742a49f/introduzione-alle-dinamiche-familiari",
        mindmap: "https://whimsical.com/generated-board-TQDqb1cuixhY4i4AC5Twjt",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTIwNTE4MS8x"
      }
    }
  },
  {
    id: 21,
    titles: {
      en: "What resources do families have in the contemporary world?",
      it: "Quali risorse hanno le famiglie nel mondo contemporaneo?"
    },
    authors: ["Roberto Losso"],
    descriptions: {
      en: "An analysis of resources available to families in the contemporary context, exploring how modern families can access and utilize different forms of support to address the challenges of today's world.",
      it: "Un'analisi delle risorse disponibili alle famiglie nel contesto contemporaneo, esplorando come le famiglie moderne possano accedere e utilizzare diverse forme di supporto per affrontare le sfide del mondo attuale."
    },
    publishDate: "2024-04-25",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/b4ba9998-ac6e-415a-97a0-0ec03a7b31d7/introduction-to-family-resources",
        mindmap: "https://whimsical.com/generated-board-8EjvWKpH1Ra74Vfano8Ta6",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81MjEzNTg0LzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/e73fb97b-c1fe-4456-a8ac-f2b8333b9475/introduzione-risorse-familiari-psicoanalisi",
        mindmap: "https://whimsical.com/generated-board-Ln6aCJFvonnPApnGCoMXrN",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTIxMjY5Ni8x"
      }
    }
  },
  {
    id: 22,
    titles: {
      en: "What resources do families have in the contemporary world? - Part 2",
      it: "Quali risorse hanno le famiglie nel mondo contemporaneo? - Parte 2"
    },
    authors: ["Roberto Losso"],
    descriptions: {
      en: "The second part of Roberto Losso's analysis examining family suffering in contemporary society and exploring additional resources and strategies available to modern families facing today's complex challenges.",
      it: "La seconda parte dell'analisi di Roberto Losso che esamina la sofferenza familiare nella società contemporanea ed esplora risorse e strategie aggiuntive disponibili alle famiglie moderne che affrontano le complesse sfide odierne."
    },
    publishDate: "2024-05-05",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/bdfea53f-1169-4beb-ae6f-a77f1d1bdc1c/introduction-family-suffering-contemporary-society",
        mindmap: "https://whimsical.com/generated-board-DENrWdemggVXacaT89vxwN",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81MjE0NDUyLzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/b8cab487-b75b-48b4-b788-bcfc91f57376/introduzione-sfide-familiari-societa-contemporanea",
        mindmap: "https://whimsical.com/generated-board-LtuTkZAA658H1d6wGjynk4",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTIxNDQ3MS8x"
      }
    }
  },
  {
    id: 23,
    titles: {
      en: "The Intrapsychic, Interpsychic and Transpsychic in Couple Psychoanalysis",
      it: "L'intrapsichico, l'interpsichico e il transpsichico nella psicoanalisi di coppia"
    },
    authors: ["Roberto Losso", "Ana Packciarz Losso"],
    descriptions: {
      en: "An exploration of the three fundamental dimensions in couple psychoanalysis: the intrapsychic (individual unconscious dynamics), the interpsychic (dynamics between partners), and the transpsychic (shared unconscious elements that transcend individual boundaries).",
      it: "Un'esplorazione delle tre dimensioni fondamentali nella psicoanalisi di coppia: l'intrapsichico (dinamiche inconsce individuali), l'interpsichico (dinamiche tra i partner) e il transpsichico (elementi inconsci condivisi che trascendono i confini individuali)."
    },
    publishDate: "2024-05-15",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/a9deee78-d438-42d0-bfcf-24d96da03b2a/introduction-to-couple-psychoanalysis",
        mindmap: "https://whimsical.com/generated-board-W2ivkCKGaqKmDe5Zhjn9qF",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81MjIyNDQ1LzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/ae34ce91-0a71-469c-adee-7084c81b8096/introduzione-psicoanalisi-coppia",
        mindmap: "https://whimsical.com/generated-board-5qg3nL6uJunyjPMhT6bxQv",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTIyMjQ0MC8x"
      }
    }
  },
  {
    id: 24,
    titles: {
      en: "Family Myths and Social Myths",
      it: "Miti familiari e miti sociali"
    },
    authors: ["Roberto Losso", "Ana Packciarz Losso"],
    descriptions: {
      en: "An exploration of how family myths and social myths shape individual and collective behavior, examining the psychological mechanisms through which these narratives influence family dynamics and social relationships.",
      it: "Un'esplorazione di come i miti familiari e sociali modellino il comportamento individuale e collettivo, esaminando i meccanismi psicologici attraverso cui queste narrazioni influenzano le dinamiche familiari e le relazioni sociali."
    },
    publishDate: "2024-05-20",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/e1ec285b-8ad6-4a22-b0ce-3eaf91d93a32/understanding-family-myths",
        mindmap: "https://whimsical.com/generated-board-W17kS2ro29q32GULHZ3rdA",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81MjI0MjU2LzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/834cb50c-b337-4387-bf07-d6c244f64e8a/comprendere-i-miti-familiari",
        mindmap: "https://whimsical.com/generated-board-EGaX73UazjzdaAVrd4A6dW",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTIyNDI1NS8x"
      }
    }
  },
  {
    id: 25,
    titles: {
      en: "Body to Body. From Suffering to the Healing Encounter. The Body in Therapy",
      it: "Corpo a corpo. Dalla sofferenza all'incontro che cura. Il corpo in terapia"
    },
    authors: ["Roberto Losso", "Ana Packciarz Losso"],
    descriptions: {
      en: "An exploration of the role of the body in therapeutic practice, examining how physical presence and embodied experiences contribute to healing and therapeutic transformation in family and systemic therapy contexts.",
      it: "Un'esplorazione del ruolo del corpo nella pratica terapeutica, esaminando come la presenza fisica e le esperienze incarnate contribuiscano alla guarigione e alla trasformazione terapeutica nei contesti di terapia familiare e sistemica."
    },
    publishDate: "2024-05-25",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/f1ea265f-d5ab-41ee-8dad-2797f08468ce/introduction-to-body-in-therapy",
        mindmap: "https://whimsical.com/generated-board-GYvQLx35BBLWa7k1ctPZCd",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81MjM0NjQ3LzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/7f2077f7-61ce-4cf8-8ff3-914cc37a9b3b/the-body-in-therapy-beyond-the-mind-body-dichotomy",
        mindmap: "https://whimsical.com/generated-board-YZkNrAd8Gh1dLke4feoJGt",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTIzNDY0Ni8x"
      }
    }
  },
  {
    id: 27,
    titles: {
      en: "The Intersubjective Space in Family Clinical Practice",
      it: "Lo spazio intersoggettivo nella clinica familiare"
    },
    authors: ["Katia Giacometti"],
    descriptions: {
      en: "An in-depth exploration of the intersubjective space in family therapy, examining how relational dynamics and co-construction processes of meaning influence therapeutic change in systemic contexts.",
      it: "Un'esplorazione approfondita dello spazio intersoggettivo nella terapia familiare, esaminando come le dinamiche relazionali e i processi di co-costruzione di significato influenzino il cambiamento terapeutico nel contesto sistemico."
    },
    publishDate: "2024-06-01",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/a027e7a7-75ea-4d43-a263-0152fe690d67/introduction-intersubjective-space-therapy",
        mindmap: "https://whimsical.com/intersubjective-space-7iTaiLKScKa8PXmPLfmsss",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81Mjc3OTE2LzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/ea678d02-fe55-4bcc-aa54-ec97584c6095/introduzione-spazio-intersoggettivo-terapia-familiare",
        mindmap: "https://whimsical.com/spazio-intersoggettivo-E1Gcdh7FWvmFqYRstU8Vqc",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTI3NzkxNS8x"
      }
    }
  },
  {
    id: 30,
    titles: {
      en: "Systemic Analysis of Violent Action: Reading Violence as Language",
      it: "Analisi sistemica dell'azione violenta: leggere la violenza come linguaggio"
    },
    authors: ["Gaetano De Leo", "Dino Mazzei"],
    descriptions: {
      en: "A systemic analysis of violent action that proposes reading violence as a form of language, exploring the relational and communicative dynamics underlying violent behaviors in family and social contexts.",
      it: "Un'analisi sistemica dell'azione violenta che propone di leggere la violenza come forma di linguaggio, esplorando le dinamiche relazionali e comunicative sottostanti ai comportamenti violenti nel contesto familiare e sociale."
    },
    publishDate: "2024-06-20",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/26df686e-9c00-4878-92b7-4b744909f900/introduction-systemic-analysis-violent-action",
        mindmap: "https://whimsical.com/violent-action-MPK79Jx7td7RXLm5896Pzt",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81MzIyOTA0LzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/2c43d901-7b43-49b2-8aa8-8e3773b5fa75/introduzione-analisi-sistemica-azioni-violente",
        mindmap: "https://whimsical.com/analisi-azione-violenta-NVwd42HzotK1wRFDLdTbqh",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTMxOTY5OS8x"
      }
    }
  },
  {
    id: 31,
    titles: {
      en: "Family Therapy as Transferential Process: Transference, Countertransference and Neuro-Psychosis from Transference",
      it: "La terapia familiare come processo transferenziale: transfert, controtransfert e neuro-psicosi da transfert"
    },
    authors: ["Alberto Eiguer"],
    descriptions: {
      en: "An exploration of family therapy through the lens of transferential processes, examining how transference, countertransference, and neuro-psychosis from transference manifest and operate within family therapeutic systems according to Alberto Eiguer's psychoanalytic approach to family therapy.",
      it: "Un'esplorazione della terapia familiare attraverso la lente dei processi transferenziali, esaminando come transfert, controtransfert e neuro-psicosi da transfert si manifestano e operano all'interno dei sistemi terapeutici familiari secondo l'approccio psicoanalitico alla terapia familiare di Alberto Eiguer."
    },
    publishDate: "2024-06-25",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/584cb167-7bb5-40dc-abfd-01397266975c/introduction-to-family-therapy-and-transference",
        mindmap: "https://whimsical.com/generated-board-Q1UHwddkkpoxv8YSbmT9mG",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81MzQ3Nzg3LzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/a8bc3fe9-6b17-4d42-a649-dd0eca598227/introduzione-terapia-familiare-transfert",
        mindmap: "https://whimsical.com/generated-board-DwC1ZeGpNGKaZ1cd6mAQLu",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTM0NjkyNC8x"
      }
    }
  },
  {
    id: 34,
    titles: {
      en: "A model of clinical intervention in developmental age",
      it: "Un modello di intervento clinico in età evolutiva"
    },
    authors: ["Giovanni Consolaro"],
    descriptions: {
      en: "An innovative model for clinical intervention in developmental age that addresses the medicalization of childhood development, offering alternative approaches to diagnostic labeling and promoting a more holistic understanding of children's psychological needs within family and social contexts.",
      it: "Un modello innovativo per l'intervento clinico in età evolutiva che affronta la medicalizzazione dello sviluppo infantile, offrendo approcci alternativi all'etichettatura diagnostica e promuovendo una comprensione più olistica dei bisogni psicologici dei bambini nei contesti familiari e sociali."
    },
    publishDate: "2024-07-10",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/0c0b37cf-44e8-4d89-8c2b-3e7eba0957b9/introduction-clinical-work-children-diagnostic-labeling",
        mindmap: "https://whimsical.com/carlo-s-workspace765/clinical-intervention-model-in-developmental-age-4ox9DypmgK34qwGG1nwBdW",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81NDQ4NDY2LzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/b4e6432a-c0ca-43ae-beb5-0f036c534e15/medicalizzazione-sviluppo-infantile",
        mindmap: "https://whimsical.com/carlo-s-workspace765/modello-di-intervento-clinico-in-eta-evolutiva-7v1keLiA6XHLv1j2BvTQzm",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTQ0ODQ3OC8x"
      }
    }
  },
  {
    id: 35,
    titles: {
      en: "Family and Individual in Psychosis",
      it: "Famiglia e individuo nelle psicosi"
    },
    authors: ["Rodolfo de Bernart"],
    descriptions: {
      en: "An exploration of the complex dynamics between family systems and individual psychotic experiences, examining how family relationships influence the development, manifestation, and treatment of psychotic disorders within a systemic framework.",
      it: "Un'esplorazione delle dinamiche complesse tra sistemi familiari ed esperienze psicotiche individuali, esaminando come le relazioni familiari influenzino lo sviluppo, la manifestazione e il trattamento dei disturbi psicotici all'interno di un quadro sistemico."
    },
    publishDate: "2024-07-15",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/0cfe3f13-df0e-4802-b8bd-5604874150bd/introduction-family-individual-dynamics",
        mindmap: "https://whimsical.com/carlo-s-workspace765/mind-map-de-bernart-english-YVb3v3bjr9MjZ1kNhcx5mt",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81NDYyNTMwLzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/26eadd5a-09ef-4907-9a20-37e67e165ee1/introduzione-problema-teorico",
        mindmap: "https://whimsical.com/carlo-s-workspace765/mind-map-de-bernart-W2oK8URRPoWuMq9DCqJuAM",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTQ2MjUyOC8x"
      }
    }
  }
];